import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["popup"]

  connect() {
    console.log('connecting remote popup')
    this.showTimer = null
    this.hideTimer = null
  }

  disconnect() {
    this.clearTimers()
  }

  showPopup(event) {
    this.clearTimers()

    console.log('showing popup')

    const link = event.currentTarget.querySelector('a')
    const menteeId = link.dataset.userId
    const menteeFormId = link.dataset.userFormId

    // Find the closest .user-indicator to get the URL
    const indicator = event.currentTarget.closest('.user-indicator')
    const url = indicator.dataset.url

    const card = event.currentTarget.closest('.card')
    const cardRect = card.getBoundingClientRect()
    const offset = {
      top: cardRect.top + window.scrollY,
      left: cardRect.left + window.scrollX - (cardRect.width + 10)
    }

    this.showTimer = setTimeout(() => {
      const urlObj = new URL(url, window.location.origin)
      urlObj.searchParams.set('mentee_id', menteeId)
      urlObj.searchParams.set('mentee_form_id', menteeFormId)

      fetch(urlObj.toString(), {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(data => {
        clearTimeout(this.hideTimer)
        this.popupTarget.innerHTML = data
        this.popupTarget.style.display = 'block'
        this.popupTarget.style.position = 'absolute'
        this.popupTarget.style.top = `${offset.top}px`
        this.popupTarget.style.left = `${offset.left}px`
        console.log(this.popupTarget)
      })
      .catch(error => console.error('Error loading popup:', error))
    }, 500)
  }

  hidePopup() {
    clearTimeout(this.showTimer)

    console.log('hiding popup')

    this.hideTimer = setTimeout(() => {
      this.popupTarget.style.display = 'none'
    }, 1000)
  }

  clearTimers() {
    if (this.showTimer) clearTimeout(this.showTimer)
    if (this.hideTimer) clearTimeout(this.hideTimer)
  }
}
